import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, inr } from "../lib/api";
import { useSeo } from "../components/site/Seo";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [res, setRes] = useState({ exams: [], products: [], blog: [] });
  useSeo({ title: `Search: ${q} | Agni Shiksha` });
  useEffect(() => { if (q) api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data)).catch(() => {}); }, [q]);
  const empty = !res.exams.length && !res.products.length && !res.blog.length;
  return (
    <div className="container-px section-y min-h-[60vh]">
      <h1 className="font-heading text-2xl font-bold mb-8">Results for “{q}”</h1>
      {empty && <div className="card-surface p-10 text-center text-content-muted">No results found. Try a different keyword.</div>}
      {res.exams.length > 0 && <Section title="Exams">{res.exams.map((e) => <Link key={e.slug} to={`/${e.slug}`} className="card-surface p-4 block hover:border-ember/60"><div className="font-medium text-sm">{e.name}</div><div className="text-xs text-content-muted">{e.short_description}</div></Link>)}</Section>}
      {res.products.length > 0 && <Section title="Test Series">{res.products.map((p) => <Link key={p.id} to={`/product/${p.slug}`} className="card-surface p-4 block hover:border-ember/60"><div className="font-medium text-sm">{p.name}</div><div className="text-xs text-ember mt-1">{p.price === 0 ? "Free" : inr(p.price)}</div></Link>)}</Section>}
      {res.blog.length > 0 && <Section title="Articles">{res.blog.map((b) => <Link key={b.id} to={`/blog/${b.slug}`} className="card-surface p-4 block hover:border-ember/60"><div className="font-medium text-sm">{b.title}</div></Link>)}</Section>}
    </div>
  );
}
const Section = ({ title, children }) => (
  <div className="mb-8"><h2 className="text-sm uppercase tracking-widest text-ember mb-3">{title}</h2><div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">{children}</div></div>
);
